module.exports = __webpack_public_path__ + "media/application/images/2023/03_still-600x338-25892b31a5e6220cd0af2edbe5c740a1.png";